export const DESIGN_DNA_FIGMA_APP_BLOCK = {
  type: 'appConnection',
  title: 'Figma',
  description: `Design system published to Enterprise Dashboard Kit`,
  iconUrl: 'https://cdn.simpleicons.org/figma/F24E1E',
  status: 'connected',
  toolkitSlug: 'figma',
  tags: ['Variables', 'Component Library', 'Enterprise Dashboard Kit'],
}

/** @param {{ streaming?: boolean }} [opts] @returns {object[]} */
